
// src/pages/Workers/Workers/AddWorkers.jsx
import { useRef, useState, useMemo, useEffect } from "react";
import { Drawer, Box, IconButton, useMediaQuery,Menu,MenuItem } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import { toast, Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Select from "react-select";
import countryList from "react-select-country-list";
import { useTranslation } from "react-i18next";
import { decryptToken } from "../../../../Utlis/Encryption";
import profilecross from "../../../../assets/profilecross.svg";
import down from "../../../../assets/down.svg";
import arrow from "../../../../assets/arrow.svg";
import drag from "../../../../assets/drag.svg";
import save from "../../../../assets/save.svg";
import { InputBase } from "@mui/material"; // Add this import at the top of your file
import CustomText, { textStyles } from "../../../../components/CustomText";
import CustomButton from "../../../../components/CustomButton";
import MultiSelectDropdown from "../../../../components/MultiSelectionDropdown";
import Location from "./Location";
import { useSelector } from "react-redux";
import "../../../../App.css";
import UpgradePromptModal from "../../../../components/UpgradeWarningModal";

import { BASE_URL } from "../../../../components/BaseUrl";
import LocationPermissionModal from "../../../../components/PermissionModal";
import { useNavigate } from "react-router-dom";
import { Country, State, City } from "country-state-city";
import document1 from "../../../../assets/document1.svg";
import imageicon from "../../../../assets/imageicon.png";
import Webcam from "react-webcam";

const AddWorkers = ({ open, onClose, onSuccess, workerToEdit }) => {
  const { t } = useTranslation();
  const imageInputRef = useRef();
  const documentInputRef = useRef();
  const isMobile = useMediaQuery("(max-width:768px)");
  const [totalWorkers, setTotalWorkers] = useState(0);
  const trialInfo = useSelector((state) => state.auth.trialInfo);
  const [showCamera, setShowCamera] = useState(false);
const [cameraTarget, setCameraTarget] = useState(null);
// "profile" | "nationalId"
const webcamRef = useRef(null);
const [capturedImage, setCapturedImage] = useState(null);
const dobRef = useRef(null);
const hireRef = useRef(null);


// menus
const [profileMenuEl, setProfileMenuEl] = useState(null);
const [docMenuEl, setDocMenuEl] = useState(null);
const openCamera = (target) => {
setCameraTarget(target);
setCapturedImage(null);
setShowCamera(true);
};
const capturePhoto = async () => {
  if (!webcamRef.current) return;

  const imageSrc = webcamRef.current.getScreenshot();
  if (!imageSrc) return toast.error("Failed to capture");

  const blob = await fetch(imageSrc).then(r => r.blob());
  const file = new File([blob], "camera.jpg", { type: "image/jpeg" });

  try {
    const url = await uploadImageToServer(file);

    if (cameraTarget === "profile") {
      setUploadedImage(url);
      setImageFile(file);
      formik.setFieldValue("profile_image_url", url);
      formik.setFieldValue("profile_image_file", file);
    }

    if (cameraTarget === "nationalId") {
      setDocumentFileName("national-id-camera.jpg");
      setDocumentImageUrl(url);
      formik.setFieldValue("document_url", url);
    }

    setShowCamera(false);
    // toast.success("Photo uploaded");
  } catch {
    toast.error("Upload failed");
  }
};
  // token
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
  // console.log("token is ", decryptedToken);
  const navigate = useNavigate();
  // local states
  const [uploadedImage, setUploadedImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [manualWorkLocation, setManualWorkLocation] = useState(true);
  const [uploadingDocument, setUploadingDocument] = useState(false);
  const [documentFileName, setDocumentFileName] = useState("");
  const [documentImageUrl, setDocumentImageUrl] = useState(null);
const [searchCountry, setSearchCountry] = useState(""); // Define state for country search
const [searchProvince, setSearchProvince] = useState(""); // Define state for province search
const [searchCity, setSearchCity] = useState(""); 
  // Manual address states
  const [showManualAddress, setShowManualAddress] = useState(false);
  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [loadingProvinces, setLoadingProvinces] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);
  const [externalCenter, setExternalCenter] = useState(null);
  const [initialAddress, setInitialAddress] = useState("");
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [upgradeMessage, setUpgradeMessage] = useState("");
  // dropdown open states
  const [departmentDropdownOpen, setDepartmentDropdownOpen] = useState(false);
  const [designationDropdownOpen, setDesignationDropdownOpen] = useState(false);
  const [employeeTypeDropdownOpen, setEmployeeTypeDropdownOpen] = useState(false);
  const [shiftDropdownOpen, setShiftDropdownOpen] = useState(false);
  const [workTypeDropdownOpen, setWorkTypeDropdownOpen] = useState(false); // UI only
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [provinceDropdownOpen, setProvinceDropdownOpen] = useState(false);
  const [cityDropdownOpen, setCityDropdownOpen] = useState(false);
const [countriesData, setCountriesData] = useState([]);
const [statesList, setStatesList] = useState([]);
const [citiesList, setCitiesList] = useState([]);


const [selectedCountryIso, setSelectedCountryIso] = useState("");

const [selectedState, setSelectedState] = useState("");
const [selectedStateIso, setSelectedStateIso] = useState("");
const NAME_ONLY_REGEX = /^[A-Za-z\s]+$/;

  // 🔹 Departments from API
  const [departments, setDepartments] = useState([]); // [{id, name}]
  const [deptLoading, setDeptLoading] = useState(false);
  const [deptError, setDeptError] = useState("");
  const [deptSearchQuery, setDeptSearchQuery] = useState("");
  
  // 🔹 Department Schedule
  const [departmentSchedule, setDepartmentSchedule] = useState(null);
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [hasSchedule, setHasSchedule] = useState(false);
  
  // Schedule form state (editable)
  const [scheduleForm, setScheduleForm] = useState({
    workingDays: [],
    startTime: "",
    endTime: "",
    graceMinutes: "",
    breakMinutes: "",
    locationName: "",
    radiusMeters: 100,
  });
  
  const fullDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // Other static options
  const designationOptions = [
    "Frontend Developer",
    "Backend Developer",
    "Full Stack Developer",
    "Mobile App Developer",
    "UI/UX Designer",
    "HR",
  ];
  const employeeTypes = [
    { value: "Full-Time", label: t("employeeTypes.fullTime") },
    { value: "Part-Time", label: t("employeeTypes.partTime") },
    { value: "Intern", label: t("employeeTypes.intern") },
    { value: "Contract", label: t("employeeTypes.contract") }
  ];
  const shiftOptions = [
    { value: "Morning", label: t("shiftOptions.morning") },
    { value: "Evening", label: t("shiftOptions.evening") },
    { value: "Night", label: t("shiftOptions.night") },
    { value: "Rotational", label: t("shiftOptions.rotational") }
  ];
  const workTypes = [
    { value: "Remote", label: t("workTypes.remote") },
    { value: "On-site", label: t("workTypes.onsite") },
    { value: "Hybrid", label: t("workTypes.hybrid") }
  ];

const getDocumentIcon = (fileNameOrUrl) => {
  if (!fileNameOrUrl) return null;

  const lower = fileNameOrUrl.toLowerCase();

  if (lower.endsWith(".pdf")) return document1;
  if (lower.match(/\.(jpg|jpeg|png|gif|webp)$/)) return imageicon;

  return document1; // fallback
};

  // 🔹 Fetch Departments
  const fetchDepartments = async () => {
    if (!decryptedToken) return;
    try {
      setDeptLoading(true);
      setDeptError("");
      const res = await fetch(`${BASE_URL}/departments?no_pagination=true`, {
        method: "GET",
        headers: { Authorization: `Bearer ${decryptedToken}` },
      });
      const json = await res.json();
      if (!res.ok || json?.error) throw new Error(json?.message || "Failed to fetch departments");
      const list = json?.data?.departments || [];
      setDepartments(list);
    } catch (err) {
      console.error("Departments GET error:", err);
      setDeptError(err.message || "Failed to fetch departments");
      setDepartments([]);
    } finally {
      setDeptLoading(false);
    }
  };

  // 🔹 Fetch Department Schedule
  const fetchDepartmentSchedule = async (departmentId) => {
    if (!departmentId || !decryptedToken) {
      setDepartmentSchedule(null);
      setHasSchedule(false);
      return;
    }
    
    try {
      setScheduleLoading(true);
      const res = await fetch(
        `${BASE_URL}/company-admins/departments/${departmentId}/attendance-settings`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      const json = await res.json();
      
      if (res.ok && !json.error && json.data?.hasSettings) {
        const { schedule, location } = json.data;
        setDepartmentSchedule({
          schedule: schedule || null,
          location: location || null,
        });
        setHasSchedule(true);
        
        // Populate schedule form with existing data
        if (schedule) {
          setScheduleForm({
            workingDays: schedule.days || [],
            startTime: schedule.start ? schedule.start.slice(0, 5) : "",
            endTime: schedule.end ? schedule.end.slice(0, 5) : "",
            graceMinutes: schedule.graceMinutes?.toString() || "",
            breakMinutes: schedule.breakPolicy?.unpaid?.toString() || "",
            locationName: location?.locationName || "",
            radiusMeters: location?.radiusMeters || 100,
          });
        }
      } else {
        setDepartmentSchedule(null);
        setHasSchedule(false);
        setScheduleForm({
          workingDays: [],
          startTime: "",
          endTime: "",
          graceMinutes: "",
          breakMinutes: "",
          locationName: "",
          radiusMeters: 100,
        });
      }
    } catch (err) {
      console.error("❌ Error fetching department schedule:", err);
      setDepartmentSchedule(null);
      setHasSchedule(false);
    } finally {
      setScheduleLoading(false);
    }
  };

  // 🔹 Filter departments based on search query
  const filteredDepartments = useMemo(() => {
    if (!deptSearchQuery.trim()) return departments;
    const query = deptSearchQuery.toLowerCase();
    return departments.filter((dept) =>
      dept.name.toLowerCase().includes(query)
    );
  }, [departments, deptSearchQuery]);

  // 🔹 Fetch Countries from countriesnow.space API (same as Location component)
  const fetchCountries = async () => {
    try {
      setLoadingCountries(true);
      const res = await fetch("https://countriesnow.space/api/v0.1/countries/states");
      const data = await res.json();

      if (Array.isArray(data?.data) && data.data.length > 0) {
        const countryList = data.data.map(country => ({
          value: country.name,
          code: country.iso2 || country.name.substring(0, 2).toUpperCase()
        })).sort((a, b) => a.value.localeCompare(b.value));
        setCountries(countryList);
      } else {
        // Fallback countries
        const fallbackCountries = [
          { value: "United States", code: "US" },
          { value: "Canada", code: "CA" },
          { value: "United Kingdom", code: "GB" },
          { value: "Germany", code: "DE" },
          { value: "France", code: "FR" },
          { value: "Spain", code: "ES" },
          { value: "Italy", code: "IT" },
          { value: "Australia", code: "AU" }
        ];
        setCountries(fallbackCountries);
      }
    } catch (err) {
      // toast.error(t("addWorker.fetchCountriesError"));
      // Fallback countries
      const fallbackCountries = [
        { value: "United States", code: "US" },
        { value: "Canada", code: "CA" },
        { value: "United Kingdom", code: "GB" },
        { value: "Germany", code: "DE" },
        { value: "France", code: "FR" },
        { value: "Spain", code: "ES" },
        { value: "Italy", code: "IT" },
        { value: "Australia", code: "AU" }
      ];
      setCountries(fallbackCountries);
    } finally {
      setLoadingCountries(false);
    }
  };

  // 🔹 Fetch Provinces/States from countriesnow.space API (same as Location component)
  const fetchProvinces = async (countryName) => {
    if (!countryName) return;
    try {
      setLoadingProvinces(true);
      setProvinces([]);
      setCities([]);
      setSelectedProvince("");
      setSelectedCity("");

      // Get states from the countriesnow.space API
      const res = await fetch("https://countriesnow.space/api/v0.1/countries/states", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ country: countryName }),
      });

      const data = await res.json();

      if (Array.isArray(data?.data?.states) && data.data.states.length > 0) {
        const provinceList = data.data.states.map(province => ({
          value: province.name,
          code: province.state_code || province.name.substring(0, 2).toUpperCase()
        }));
        setProvinces(provinceList);
      } else {
        // Fallback provinces
        const fallbackProvinces = [
          { value: "California", code: "CA" },
          { value: "New York", code: "NY" },
          { value: "Texas", code: "TX" },
          { value: "Florida", code: "FL" },
          { value: "Illinois", code: "IL" },
          { value: "Ontario", code: "ON" },
          { value: "Quebec", code: "QC" },
          { value: "British Columbia", code: "BC" }
        ];
        setProvinces(fallbackProvinces);
      }
    } catch (err) {
      // Fallback provinces
      const fallbackProvinces = [
        { value: "California", code: "CA" },
        { value: "New York", code: "NY" },
        { value: "Texas", code: "TX" },
        { value: "Florida", code: "FL" }
      ];
      setProvinces(fallbackProvinces);
    } finally {
      setLoadingProvinces(false);
    }
  };

  // 🔹 Fetch Cities from countriesnow.space API (same as Location component)
  const fetchCities = async (countryName, stateName) => {
    if (!countryName || !stateName) return;
    try {
      setLoadingCities(true);
      setCities([]);
      setSelectedCity("");

      const res = await fetch("https://countriesnow.space/api/v0.1/countries/state/cities", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ country: countryName, state: stateName }),
      });

      const data = await res.json();

      if (Array.isArray(data?.data) && data.data.length > 0) {
        const cityList = data.data.map(city => ({
          value: city,
          code: city.substring(0, 3).toUpperCase()
        }));
        setCities(cityList);
      } else {
        // Fallback cities
        const fallbackCities = [
          { value: "Los Angeles", code: "LA" },
          { value: "San Francisco", code: "SF" },
          { value: "San Diego", code: "SD" },
          { value: "Sacramento", code: "SAC" }
        ];
        setCities(fallbackCities);
      }
    } catch (err) {
      // Fallback cities
      const fallbackCities = [
        { value: "Los Angeles", code: "LA" },
        { value: "San Francisco", code: "SF" },
        { value: "San Diego", code: "SD" }
      ];
      setCities(fallbackCities);
    } finally {
      setLoadingCities(false);
    }
  };


  useEffect(() => {
  const list = Country.getAllCountries().map((c) => ({
    name: c.name,
    isoCode: c.isoCode,
  }));
  setCountriesData(list);
}, []);



  // Set default location values
  const setDefaultLocationValues = () => {
    // Default coordinates (Pakistan - Islamabad)
    const defaultLat = 33.6844;
    const defaultLng = 73.0479;

    // Set default values
    formik.setFieldValue("latitude", defaultLat);
    formik.setFieldValue("longitude", defaultLng);
    formik.setFieldValue("assign_region", ["North"]); // Default region
    formik.setFieldValue("country", "Pakistan");
    formik.setFieldValue("province", "Islamabad Capital Territory");
    formik.setFieldValue("city", "Islamabad");

    // Set external center for map
    setExternalCenter({ lat: defaultLat, lng: defaultLng });
  };

  // Reset & fetch when drawer opens (only if not editing)
  useEffect(() => {
    if (open && !workerToEdit) {
      formik.resetForm();
      setUploadedImage(null);
      setImageFile(null);
      setManualWorkLocation(true);
      setMissingFields([]);
      setDocumentFileName("");
      setDocumentImageUrl(null);
      setUploadingDocument(false);
      setShowManualAddress(false);
      setSelectedCountry("");
      setSelectedProvince("");
      setSelectedCity("");
      setProvinces([]);
      setCities([]);
      
      // Reset external center - let Location component get user's actual location first
      setExternalCenter(null);
      setInitialAddress("");

      // Don't set default location immediately - let Location component get user's actual location
      // Only set default as fallback if geolocation is not available (handled in Location component)

      fetchDepartments();
      fetchCountries();
    } else if (open && workerToEdit) {
      // When editing, just fetch departments and countries
      fetchDepartments();
      fetchCountries();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, workerToEdit]);

  // =======================
  // Validation helpers
  // =======================
  const REQUIRED_KEYS = [
    "first_name",
    "last_name",
    "email",
    "phone",
    // "dob",  // ✅ Made optional
    // "password",
    "department_id",
    // "designation",
    // "employee_type",
    // "hire_date",
    // "assign_region",

    "country",
    // "community",
    "province",
    "latitude",
    "longitude",
    "city",
    // "postal_code",     // ✅ Made optional
    // "street_address",  // ✅ Made optional
    // "shift_schedule",
    // "salary",          // ✅ Made optional
    // "work_hours",      // ✅ Made optional
  ];

  const FIELD_LABELS = {
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    phone: "Phone",
    dob: "Date of Birth",
    // password: "Password",
    department_id: "Department",
    // designation: "Designation",
    employee_type: "Employee Type",
    hire_date: "Hire Date",
    assign_region: "Assign Region",

    country: "Country",
    community: "Community",
    province: "Province",
    city: "City",
    postal_code: "Postal Code",
    street_address: "Street Address",
    shift_schedule: "Shift Schedule",
  };

  const isEmpty = (v) => {
    if (v === null || v === undefined) return true;
    if (typeof v === "string") return v.trim() === "";
    if (Array.isArray(v)) return v.length === 0;
    return false;
  };

  const validateRequired = (values) => {
    const missing = [];
    for (const k of REQUIRED_KEYS) {
      const v = values[k];
      if (k === "department_id") {
        if (!values.department_id || Number.isNaN(Number(values.department_id))) {
          missing.push(k);
        }
      }
       if (k === "assign_region") {
        if (!Array.isArray(values.assign_region) || values.assign_region.length === 0) {
          missing.push(k);
        }
      } else if (isEmpty(v)) {
        missing.push(k);
      }
    }


    console.log("🧪 Preflight validation missing:", missing);
    // extra phone sanity (7-15 digits)
    if (!/^\d{7,15}$/.test(String(values.phone || ""))) {
      if (!missing.includes("phone")) missing.push("phone");
    }
    return missing;
  };



  const buildJSONPayload = (v) => ({
    first_name: v.first_name,
    last_name: v.last_name,
    middle_name: v.middle_name || "",
    email: v.email,
    phone: v.phone,
    // password: v.password || "yourPassword123",
    department_id: Number(v.department_id),
    designation: v.designation || "",
    employee_type: v.employee_type,
      ...(v.hire_date && v.hire_date.trim()
    ? { hire_date: v.hire_date.slice(0, 10) }
    : {}),
    assign_region: Array.isArray(v.assign_region) ? v.assign_region : [],
    assign_zone: v.assign_zone || null,
    // salary: v.salary ? Number(v.salary) : null,
    salary:
  v.salary === "" || v.salary === null || v.salary === undefined
    ? null
    : Number(v.salary),
    work_hours: v.work_hours ? Number(v.work_hours) : null,
    document_url: v.document_url || "",

    country: v.country || "",
    community: v.community || "",
    province: v.province || "",
    city: v.city || "",
    postal_code: v.postal_code || "", // Optional field
    street_address: v.street_address || "", // Optional field
    work_address: v.work_address || "", // Work address field
    latitude: v.latitude || "",
    longitude: v.longitude || "",
    shift_schedule: v.shift_schedule || "",
    primary_color: v.primary_color || "",
    secondary_color: v.secondary_color || "",
    position: v.designation || "", // Add position field (same as designation)
    worker_id: v.employee_id || "", // Add worker_id field (employee ID)
    // Optional fields
    ...(v.dob && v.dob.trim() ? { dob: v.dob.slice(0, 10) } : {}),
    ...(v.profile_image_url ? { profile_image: v.profile_image_url } : {}),
    ...(v.face_data && Object.keys(v.face_data).length > 0
      ? { face_data: v.face_data }
      : {}),
  });

  const [missingFields, setMissingFields] = useState([]);
  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      middle_name: "",
      email: "",
      phone: "",
      dob: "",
      // password: "",
      department_id: "",
      designation: "",
      employee_type: "",
      hire_date: "",
      shift_schedule: "",
      assign_region: [],
      assign_zone: null,
      salary: "",
      work_hours: "",
      document_url: "",
      country: "",
      community: "",
      province: "",
      city: "",
      postal_code: "",
      street_address: "",
      work_address: "",
      latitude: "",
      longitude: "",
      face_data: {},
      profile_image_file: null,
      profile_image_url: "",
      workType: "",
      primary_color: "",
      secondary_color: "",
      employee_id: "",
    },

    validate: (values) => {
      const errors = {};
      
      // First Name
      if (!values.first_name || values.first_name.trim() === "") {
        errors.first_name = t("addWorker.validation.firstNameRequired") || "First name is required";
      } else if (!NAME_ONLY_REGEX.test(values.first_name.trim())) {
        errors.first_name = "Only letters and spaces are allowed";
      }
      
      // Last Name
      if (!values.last_name || values.last_name.trim() === "") {
        errors.last_name = t("addWorker.validation.lastNameRequired") || "Last name is required";
      } else if (!NAME_ONLY_REGEX.test(values.last_name.trim())) {
        errors.last_name = "Only letters and spaces are allowed";
      }

      // Middle Name (optional, but must be valid when provided)
      if (values.middle_name && values.middle_name.trim() !== "" && !NAME_ONLY_REGEX.test(values.middle_name.trim())) {
        errors.middle_name = "Only letters and spaces are allowed";
      }
      
      // Email
      if (!values.email || values.email.trim() === "") {
        errors.email = t("addWorker.validation.emailRequired") || "Email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
        errors.email = t("addWorker.validation.emailInvalid") || "Invalid email format";
      }
      
      // Phone
      if (!values.phone || values.phone.trim() === "") {
        errors.phone = t("addWorker.validation.phoneRequired") || "Phone is required";
      } else if (!/^\d{7,15}$/.test(String(values.phone))) {
        errors.phone = t("addWorker.validation.phoneInvalid") || "Phone must be 7-15 digits";
      }
      
      // Date of Birth
      // ✅ Made optional - DOB is no longer required
      // if (!values.dob || values.dob.trim() === "") {
      //   errors.dob = t("addWorker.validation.dobRequired") || "Date of birth is required";
      // }
      
      
      if (!values.department_id || Number.isNaN(Number(values.department_id))) {
        errors.department_id = t("addWorker.validation.departmentRequired") || "Department is required";
      }
      
      // Employee Type
    //  else  if (!values.employee_type || values.employee_type.trim() === "") {
    //     errors.employee_type = t("addWorker.validation.employeeTypeRequired") || "Employee type is required";
    //   }
      
      // Hire Date
      // if (!values.hire_date || values.hire_date.trim() === "") {
      //   errors.hire_date = t("addWorker.validation.hireDateRequired") || "Hire date is required";
      // }
      
      // Assign Region
      // if (!Array.isArray(values.assign_region) || values.assign_region.length === 0) {
      //   errors.assign_region = t("addWorker.validation.assignRegionRequired") || "Assign region is required";
      // }
      
      // Country
      if (!values.country || values.country.trim() === "") {
        errors.country = t("addWorker.validation.countryRequired") || "Country is required";
      }
      
      // Province
      if (!values.province || values.province.trim() === "") {
        errors.province = t("addWorker.validation.provinceRequired") || "Province is required";
      }
      
      // City
      if (!values.city || values.city.trim() === "") {
        errors.city = t("addWorker.validation.cityRequired") || "City is required";
      }
      
      // Latitude
      if (!values.latitude || values.latitude === "") {
        errors.latitude = t("addWorker.validation.latitudeRequired") || "Location is required";
      }
      
      // Longitude
      if (!values.longitude || values.longitude === "") {
        errors.longitude = t("addWorker.validation.longitudeRequired") || "Location is required";
      }
      
      // Shift Schedule
      // if (!values.shift_schedule || values.shift_schedule.trim() === "") {
      //   errors.shift_schedule = t("addWorker.validation.shiftScheduleRequired") || "Shift schedule is required";
      // }
      
          if (showManualAddress) {
  if (!values.country || values.country.trim() === "") {
    errors.country = t("addWorker.validation.countryRequired") || "Country is required";
  }

  if (!values.province || values.province.trim() === "") {
    errors.province = t("addWorker.validation.provinceRequired") || "Province is required";
  }

  if (!values.city || values.city.trim() === "") {
    errors.city = t("addWorker.validation.cityRequired") || "City is required";
  }
}
      // Salary
      // if (!values.salary || values.salary.toString().trim() === "") {
      //   errors.salary = t("addWorker.validation.salaryRequired") || "Salary is required";
      // }
      
      // Work Hours
      // if (!values.work_hours || values.work_hours.toString().trim() === "") {
      //   errors.work_hours = t("addWorker.validation.workHoursRequired") || "Work hours is required";
      // }
      
      return errors;
    },

    validateOnBlur: true,
    validateOnChange: true,

    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (!decryptedToken) {
          toast.error(t("addWorker.missingToken"));
          setSubmitting(false);
          return;
        }

        // ✅ Step 1: Validate using formik errors
        // Formik validation already runs, but we check here too
        const missing = validateRequired(values);
        if (missing.length) {
          setMissingFields(missing);
          console.log("❌ Missing fields:", missing);
          toast.error(t("addWorker.fillRequiredFields"));
          setSubmitting(false);
          return;
        } else {
          setMissingFields([]);
        }

        setLoading(true);

        // ✅ Step 2: Prepare request
        const isEditMode = !!workerToEdit?.id;
        const url = isEditMode 
          ? `${BASE_URL}/company-admins/workers/${workerToEdit.id}`
          : `${BASE_URL}/company-admins/workers`;
        const headers = {
          Authorization: `Bearer ${decryptedToken}`,
          "Content-Type": "application/json",
        };
        const payload = buildJSONPayload(values);

        console.log(`🧪 ${isEditMode ? "Update" : "Create"} Worker Payload:`, payload);
        // ✅ Step 3: Call API
        const res = await fetch(url, {
          method: isEditMode ? "PUT" : "POST",
          headers,
          body: JSON.stringify(payload),
        });

        console.log(" response of add worker", res)
        // ✅ Step 4: Parse response
        const raw = await res.text();

        let json;
        try {
          json = JSON.parse(raw);
        } catch {
          json = { raw };
        }

        console.log("📤 API Response Status:", res.status);
        console.log("📤 API Response JSON:", json);

        // ✅ Step 5: Error handling
        if (!res.ok || json?.error) {
          // alert(`❌ API Error: ${json?.message || `Failed to ${isEditMode ? "update" : "create"} worker.`}`);
          throw new Error(json?.message || `Failed to ${isEditMode ? "update" : "create"} worker.`);
        }


        toast.success(isEditMode ? t("addWorker.workerUpdated")  : t("addWorker.workerCreated"));
        onSuccess?.();
        onClose();
      } catch (err) {
        console.error("Create Worker Error:", err);
        toast.error(err.message || t("addWorker.somethingWrong"));
        // alert(`❌ Error: ${err.message || "Something went wrong."}`);
      } finally {
        setLoading(false);
      }
    },



  });

  // 🔹 Fetch worker data when editing
  useEffect(() => {
    const fetchWorkerData = async () => {
      if (!workerToEdit?.id || !decryptedToken || !open) return;
      
      try {
        setLoading(true);
        const response = await fetch(`${BASE_URL}/company-admins/workers/${workerToEdit.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
        });
        
        const data = await response.json();
        
        if (data.error) {
          throw new Error(data.message);
        }
        
        const workerData = data.data;
        console.log("📥 Fetched worker data for editing:", workerData);
        
        // Extract address object fields
        const workerAddress = workerData.address || {};
        

        
  const apiEmployeeType = workerData.employeeType || "";

const normalizedEmployeeType = employeeTypes.find(
  (et) =>
    et.value.replace("-", " ").toLowerCase() ===
    apiEmployeeType.toLowerCase()
)?.value || "";

        // Parse assignRegion if it's a JSON string
        let assignRegionArray = [];
        if (workerData.assignRegion) {
          try {
            const parsed = typeof workerData.assignRegion === "string" 
              ? JSON.parse(workerData.assignRegion) 
              : workerData.assignRegion;
            assignRegionArray = Array.isArray(parsed) ? parsed : (parsed ? [parsed] : []);
          } catch {
            assignRegionArray = Array.isArray(workerData.assignRegion) 
              ? workerData.assignRegion 
              : (workerData.assignRegion ? [workerData.assignRegion] : []);
          }
        } else if (workerData.assign_region) {
          assignRegionArray = Array.isArray(workerData.assign_region) 
            ? workerData.assign_region 
            : (workerData.assign_region ? [workerData.assign_region] : []);
        }
        
        // Prefill form with worker data - handle both camelCase and snake_case
        formik.setValues({
          first_name: workerData.firstName || workerData.first_name || "",
          last_name: workerData.lastName || workerData.last_name || "",
          middle_name: workerData.middleName || workerData.middle_name || "",
          email: workerData.email || "",
          phone: workerData.phone || "",
          dob: workerData.dob ? (workerData.dob.split("T")[0] || workerData.dob) : "",
          department_id: workerData.department?.id || workerData.department_id || "",
          designation: workerData.designation || workerData.position || "",
          // employee_type: workerData.employeeType || workerData.employee_type || "",
          employee_type: normalizedEmployeeType,
          hire_date: workerData.hireDate ? (workerData.hireDate.split("T")[0] || workerData.hireDate) : (workerData.hire_date ? workerData.hire_date.split("T")[0] : ""),
          shift_schedule: workerData.shiftSchedule || workerData.shift_schedule || "",
          assign_region: assignRegionArray,
          assign_zone: workerData.assignZone || workerData.assign_zone || null,
          salary: workerData.salary || "",
          work_hours: workerData.workHours || workerData.work_hours || "",
          document_url: workerData.documentUrl || workerData.document_url || "",
          // Address fields - check both address object and direct fields
          country: workerAddress.country || workerData.country || "",
          province: workerAddress.province || workerData.province || workerData.state || "",
          city: workerAddress.city || workerData.city || "",
          postal_code: workerAddress.postalCode || workerAddress.postal_code || workerData.postalCode || workerData.postal_code || "",
          street_address: workerAddress.streetAddress || workerAddress.street_address || workerData.streetAddress || workerData.street_address || "",
          community: workerAddress.community || workerData.community || "",
          work_address: workerData.workAddress || workerData.work_address || "",
          latitude: workerData.latitude || (typeof workerData.latitude === "string" ? parseFloat(workerData.latitude) : "") || "",
          longitude: workerData.longitude || (typeof workerData.longitude === "string" ? parseFloat(workerData.longitude) : "") || "",
          face_data: workerData.faceData || workerData.face_data || {},
          profile_image_file: null,
          profile_image_url: workerData.profileImage || workerData.profile_image || "",
          workType: workerData.workType || workerData.work_type || "",
          primary_color: workerData.primaryColor || workerData.primary_color || "",
          secondary_color: workerData.secondaryColor || workerData.secondary_color || "",
          employee_id: workerData.employeeId || workerData.employee_id || workerData.worker_id || "",
        });
        
        // Set profile image if exists
        const profileImageUrl = workerData.profileImage || workerData.profile_image || "";
        if (profileImageUrl) {
          setUploadedImage(profileImageUrl);
        }
        
        // Set document image if exists (National ID)
        const docUrl = workerData.documentUrl || workerData.document_url || "";
        if (docUrl) {
          setDocumentImageUrl(docUrl);
        }
        
        // Set location if exists - parse latitude/longitude
        const latStr = workerData.latitude || "";
        const lngStr = workerData.longitude || "";
        const lat = latStr ? (typeof latStr === "string" ? parseFloat(latStr) : latStr) : null;
        const lng = lngStr ? (typeof lngStr === "string" ? parseFloat(lngStr) : lngStr) : null;
        
        // Set address fields from address object first (more accurate)
        const country = workerAddress.country || workerData.country || "";
        const province = workerAddress.province || workerData.province || workerData.state || "";
        const city = workerAddress.city || workerData.city || "";
        const postalCode = workerAddress.postalCode || workerAddress.postal_code || workerData.postalCode || workerData.postal_code || "";
        const streetAddress = workerAddress.streetAddress || workerAddress.street_address || workerData.streetAddress || workerData.street_address || "";
        const community = workerAddress.community || workerData.community || "";
        
        // Build formatted address string from address object
        const addressParts = [
          streetAddress,
          community,
          city,
          province,
          postalCode,
          country
        ].filter(Boolean);
        const formattedAddress = addressParts.length > 0 ? addressParts.join(", ") : "";
        
        // Set initial address immediately if we have one from address object
        // This will show while reverse geocoding happens
        if (formattedAddress) {
          setInitialAddress(formattedAddress);
        }
        
        // Update formik with address object values (these are already set in formik.setValues above)
        // But also update dropdowns for UI
        if (country) {
          setSelectedCountry(country);
        }
        if (province) {
          setSelectedProvince(province);
        }
        if (city) {
          setSelectedCity(city);
        }
        
        // Set map location - Location component will fetch address from lat/long
        // This will fetch and display the address from coordinates
        if (lat && lng && !isNaN(lat) && !isNaN(lng)) {
          // Set external center for map - Location component expects {lat, lng} object
          // The Location component will automatically fetch address from coordinates
          // and call onChange, which will update formik values
          // We use a small delay to ensure formik values are set first from address object
          setTimeout(() => {
            setExternalCenter({ lat, lng });
          }, 200);
        }
        
      } catch (err) {
        console.error("Error fetching worker data:", err);
        toast.error(err.message || "Failed to load worker data");
      } finally {
        setLoading(false);
      }
    };
    
    fetchWorkerData();
  }, [workerToEdit?.id, open, decryptedToken]);

  // 🔹 Fetch schedule when department_id changes or drawer opens
  useEffect(() => {
    if (open && formik.values.department_id) {
      fetchDepartmentSchedule(formik.values.department_id);
    } else if (!open) {
      // Reset schedule when drawer closes
      setDepartmentSchedule(null);
      setHasSchedule(false);
      setScheduleForm({
        workingDays: [],
        startTime: "",
        endTime: "",
        graceMinutes: "",
        breakMinutes: "",
        locationName: "",
        radiusMeters: 100,
      });
      setDeptSearchQuery("");
    }
  }, [open, formik.values.department_id]);

  const handleImagePick = () => imageInputRef.current?.click();

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      setLoading(true);
      const dataUrl = await fileToDataUrl(file);
      setUploadedImage(dataUrl);
      setImageFile(file);

      // Upload to server and get URL
      const uploadedUrl = await uploadImageToServer(file);

      // Store the server URL in formik
      formik.setFieldValue("profile_image_url", uploadedUrl);
      formik.setFieldValue("profile_image_file", file);

      toast.success(t("addWorker.imageUploaded"));
    } catch (err) {
      toast.error(t("addWorker.imageUploadFailed"));
      setUploadedImage(null);
      setImageFile(null);
      formik.setFieldValue("profile_image_url", "");
      formik.setFieldValue("profile_image_file", null);
    } finally {
      setLoading(false);
      if (imageInputRef.current) imageInputRef.current.value = "";
    }
  };

  // Document upload functions
  const fileToDataUrl = (file) =>
    new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => resolve(fr.result);
      fr.onerror = reject;
      fr.readAsDataURL(file);
    });

  const uploadImageToServer = async (file) => {
    const form = new FormData();
    form.append("image", file);

    const res = await fetch(`${BASE_URL}/upload/image`, {
      method: "POST",
      body: form,
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Upload failed");

    return data?.data?.url || data?.url || data?.path || "";
  };





  const handleDocumentChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // ✅ Automatically detect file type
    const type = file.type.startsWith("image/")
      ? "image"
      : file.type === "application/pdf"
        ? "pdf"
        : null;

    if (!type) {
      toast.error(t("addWorker.validFileError"));
      if (documentInputRef.current) documentInputRef.current.value = "";
      return;
    }

    try {
      setUploadingDocument(true);
      setDocumentFileName(file.name);

      // ✅ Build FormData
      const form = new FormData();
      form.append(type, file);

      // ✅ Select correct endpoint
      const endpoint = type === "image" ? "/upload/image" : "/upload/pdf";

      const res = await fetch(`${BASE_URL}${endpoint}`, {
        method: "POST",
        body: form,
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || "Upload failed");

      const uploadedUrl = data?.data?.url || data?.url || data?.path || "";

      // ✅ Save to Formik
      formik.setFieldValue("document_url", uploadedUrl);
      toast.success(t("addWorker.documentUploaded", { type: type.toUpperCase() }));
    } catch (err) {
      toast.error(err.message || t("addWorker.uploadFailed"));
      formik.setFieldValue("document_url", "");
      setDocumentFileName("");
    } finally {
      setUploadingDocument(false);
      if (documentInputRef.current) documentInputRef.current.value = "";
    }
  };


  const handleDocumentPick = () => documentInputRef.current?.click();

  // Helper: selected department label by id
  const selectedDeptName =
    departments.find((d) => d.id === Number(formik.values.department_id))?.name ||
    t("addCompanyAdmin.select");

  const [locationAllowed, setLocationAllowed] = useState(null);
  const [showPermissionModal, setShowPermissionModal] = useState(false);

// const handleCountryChange = (value) => {
//   setSelectedCountry(value);
//   setSelectedState("");
//   setSelectedCity("");

//   const obj = countriesData.find(c => c.name === value);

//   if (obj) {
//     setSelectedCountryIso(obj.isoCode);

//     const stateList = State.getStatesOfCountry(obj.isoCode).map((s) => ({
//       name: s.name,
//       isoCode: s.isoCode,
//     }));

//     setStatesList(stateList);
//   }

//   formik.setFieldValue("country", value);
// };


const handleCountryChange = (countryObj) => {
  const countryName = countryObj?.name || "";
  const iso = countryObj?.isoCode || "";

  setSelectedCountry(countryName);
  setSelectedCountryIso(iso);

  setSelectedState("");
  setSelectedStateIso("");
  setSelectedProvince("");
  setSelectedCity("");

  setStatesList(
    State.getStatesOfCountry(iso).map((s) => ({
      name: s.name,
      isoCode: s.isoCode,
    }))
  );

  setCitiesList([]);

  formik.setFieldValue("country", countryName);
  formik.setFieldValue("province", "");
  formik.setFieldValue("city", "");
};


// const handleStateChange = (value) => {
//   setSelectedState(value);
//   setSelectedCity("");

//   formik.setFieldValue("province", value);

//   const obj = statesList.find(s => s.name === value);

//   if (obj) {
//     setSelectedStateIso(obj.isoCode);
//     const cityList = City.getCitiesOfState(selectedCountryIso, obj.isoCode)
//       .map((c) => c.name);

//     setCitiesList(cityList);
//   }
// };

const handleStateChange = (value) => {
  setSelectedState(value);
  setSelectedProvince(value);
  setSelectedCity("");

  formik.setFieldValue("province", value);
  formik.setFieldValue("city", "");

  const obj = statesList.find((s) => s.name === value);
  if (!obj || !selectedCountryIso) return;

  setSelectedStateIso(obj.isoCode);

  const cityList = City.getCitiesOfState(selectedCountryIso, obj.isoCode).map((c) => c.name);
  setCitiesList(cityList);
};


const handleCityChange = async (value) => {
  setSelectedCity(value);
  formik.setFieldValue("city", value);

  const query = `${value}, ${selectedState}, ${selectedCountry}`;

  const geo = await fetch(
    `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=1`
  ).then(r => r.json());

  if (geo.length > 0) {
    const lat = parseFloat(geo[0].lat);
    const lng = parseFloat(geo[0].lon);
    formik.setFieldValue("latitude", lat);
    formik.setFieldValue("longitude", lng);
    setExternalCenter({ lat, lng });
  }
};

const clearLocationFieldsForManualMode = () => {
  setSelectedCountry("");
  setSelectedCountryIso("");
  setSelectedState("");
  setSelectedStateIso("");
  setSelectedProvince("");
  setSelectedCity("");
  setStatesList([]);
  setCitiesList([]);
  setSearchCountry("");
  setSearchProvince("");
  setSearchCity("");

  formik.setFieldValue("country", "");
  formik.setFieldValue("province", "");
  formik.setFieldValue("city", "");
  formik.setFieldValue("community", "");
  formik.setFieldValue("postal_code", "");
  formik.setFieldValue("street_address", "");
  formik.setFieldValue("work_address", "");
  formik.setFieldValue("latitude", "");
  formik.setFieldValue("longitude", "");
  formik.setFieldValue("assign_region", []);
};

const handleManualAddressToggle = (isChecked) => {
  setShowManualAddress(isChecked);

  // In add mode, manual address should start empty.
  if (isChecked && !workerToEdit) {
    clearLocationFieldsForManualMode();
  }
};

const [triggerProfileFile, setTriggerProfileFile] = useState(false);
useEffect(() => {
  if (!profileMenuEl && triggerProfileFile) {
    handleImagePick();
    setTriggerProfileFile(false);
  }
}, [profileMenuEl, triggerProfileFile]);


const dropdownRef = useRef(null);
useEffect(() => {
  const handleClickOutside = (event) => {
    // If click is inside any dropdown-wrapper, do nothing
    if (event.target.closest(".dropdown-wrapper")) return;

    // Otherwise close all dropdowns
    setDepartmentDropdownOpen(false);
    setEmployeeTypeDropdownOpen(false);
    setShiftDropdownOpen(false);
    setCountryDropdownOpen(false);
    setProvinceDropdownOpen(false);
    setCityDropdownOpen(false);
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);



  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: 550,
            maxWidth: "100%",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Toaster />
        {/* Header */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            backgroundColor: "#E7EBEE",
            p: 1.3,
            borderBottom: "1px solid #E0E0E0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.2 }}>
            <IconButton onClick={onClose}>
              <img src={profilecross} alt="close" />
            </IconButton>
            <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 600, color: "#2C384C" }}>
              {workerToEdit ? (t("common.edit") + " " + t("common.worker")) : t("addCompanyAdmin.titleName")}
            </CustomText>
          </Box>
        </Box>

        <Box sx={{ p: 2, overflowY: "auto", flexGrow: 1 }}  ref={dropdownRef}>
          {/* Personal Details */}
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              mb: 3,
              mt: 1,
              fontWeight: 600,
              color: "#000",
              textAlign: "left",
            }}
          >
            {t("addCompanyAdmin.personalDetails")}
          </CustomText>

          {/* Name Fields: First Name → Middle Name → Last Name */}
          <Box display="flex" gap={1.5} mb={2}>
            <Box sx={{ flex: 1 }}>
              <label className="field_label">
                {t("addCompanyAdmin.firstName")} <span className="red_asterisk">*</span>
              </label>
              <input
                className="project_input"
                style={{ height: "40px", width: "100%",
                     border: formik.touched.first_name && formik.errors.first_name
      ? "2px solid #d32f2f" // Red border if the field has error
      : "2px solid #091E4224"
                 }}
                name="first_name"
                value={formik.values.first_name}
                onChange={(e) => {
                  const sanitizedValue = e.target.value
                    .replace(/[^A-Za-z\s]/g, "")
                    .replace(/\s{2,}/g, " ");
                  formik.setFieldValue("first_name", sanitizedValue);
                  formik.setFieldTouched("first_name", true, false);
                }}
                onBlur={formik.handleBlur}
              />
              {formik.touched.first_name && formik.errors.first_name && (
                <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                  {formik.errors.first_name}
                </span>
              )}
            </Box>
            <Box sx={{ flex: 1 }}>
              <label className="field_label">
                {t("middleName") || "Middle Name"}
              </label>
              <input
                className="project_input"
                style={{
                  height: "40px",
                  width: "100%",
                  border: formik.touched.middle_name && formik.errors.middle_name
                    ? "2px solid #d32f2f"
                    : "2px solid #091E4224"
                }}
                name="middle_name"
                value={formik.values.middle_name}
                onChange={(e) => {
                  const sanitizedValue = e.target.value
                    .replace(/[^A-Za-z\s]/g, "")
                    .replace(/\s{2,}/g, " ");
                  formik.setFieldValue("middle_name", sanitizedValue);
                  formik.setFieldTouched("middle_name", true, false);
                }}
                onBlur={formik.handleBlur}
              />
              {formik.touched.middle_name && formik.errors.middle_name && (
                <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                  {formik.errors.middle_name}
                </span>
              )}
            </Box>
            <Box sx={{ flex: 1 }}>
              <label className="field_label">{t("addCompanyAdmin.lastName")}</label><span className="red_asterisk">*</span>
              <input
                className="project_input"
                style={{ height: "40px", width: "100%",
                     border: formik.touched.last_name && formik.errors.last_name
      ? "2px solid #d32f2f"
      : "2px solid #091E4224"
               



                 }}
                name="last_name"
                value={formik.values.last_name}
                onChange={(e) => {
                  const sanitizedValue = e.target.value
                    .replace(/[^A-Za-z\s]/g, "")
                    .replace(/\s{2,}/g, " ");
                  formik.setFieldValue("last_name", sanitizedValue);
                  formik.setFieldTouched("last_name", true, false);
                }}
                onBlur={formik.handleBlur}
              />
              {formik.touched.last_name && formik.errors.last_name && (
                <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                  {formik.errors.last_name}
                </span>
              )}
            </Box>
          </Box>

          <Box display="flex" gap={1.5} mb={2}>
            <Box sx={{ flex: 1 }}>
              <label className="field_label">
                {t("addCompanyAdmin.email")} <span className="red_asterisk">*</span>
              </label>
              <input
                className="project_input"
                style={{ height: "40px", width: "100%",
                  border: formik.touched.email && formik.errors.email
      ? "2px solid #d32f2f"
      : "2px solid #091E4224"
                 }}
                name="email"
                type="email"
                value={formik.values.email}
                onChange={(e) => {
                  formik.setFieldValue("email", e.target.value.toLowerCase());
                  formik.setFieldTouched("email", true, false);
                }}
                onBlur={formik.handleBlur}
              />
              {formik.touched.email && formik.errors.email && (
                <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                  {formik.errors.email}
                </span>
              )}
            </Box>

            <Box sx={{ flex: 1 }}>
              <label className="field_label">
                {t("addCompanyAdmin.phoneNo")} <span className="red_asterisk">*</span>
              </label>
              <Box
                sx={{
                  border: formik.touched.phone && formik.errors.phone ? "2px solid #d32f2f" : "2px solid rgba(9,30,66,0.14)",
                  borderRadius: "6px",
                  backgroundColor: "white",
                  "& .form-control": {
                    border: "none !important",
                    outline: "none !important",
                    boxShadow: "none !important",
                    width: "100%",
                    height: "36px",
                    fontSize: "14px",
                    paddingLeft: "48px",
                    borderRadius: "6px",
                    fontFamily: "Poppins, sans-serif !important",
                    backgroundColor: "transparent",
                  },
                  "& .flag-dropdown": {
                    border: "none !important",
                    borderRight: "1px solid #ccc !important",
                    backgroundColor: "#f9f9f9",
                    borderTopLeftRadius: "6px",
                    borderBottomLeftRadius: "6px",
                  },
                }}
              >
                <PhoneInput
                  countryCodeEditable={false}
                  country={"us"}
                  value={formik.values.phone}
                  onChange={(value) => {
                    formik.setFieldValue("phone", value);
                    formik.setFieldTouched("phone", true);
                  }}
                  onBlur={() => formik.setFieldTouched("phone", true)}
                  inputProps={{ name: "phone", required: true }}
                  containerClass="react-tel-input"
                  inputClass="form-control"
                  buttonClass="flag-dropdown"
                />
              </Box>
              {formik.touched.phone && formik.errors.phone && (
                <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                  {formik.errors.phone}
                </span>
              )}
            </Box>
          </Box>

          <Box display="flex" gap={1.5} mb={2}>
      <Box sx={{ flex: 1 }}>
  <label className="field_label">
    {t("addCompanyAdmin.dob")} 
  </label>

  <input
    ref={dobRef}
    type="date"
    className="project_input"
    name="dob"
    value={formik.values.dob}
    onClick={() => dobRef.current?.showPicker()} 
    onChange={(e) => {
      let val = e.target.value;

      // Limit year length to 4 digits
      const parts = val.split("-");
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4);
      }
      val = parts.join("-");

      // ---- AGE VALIDATION (18+) ----
      if (val && val.trim() !== "") {
        try {
          const today = new Date();
          const dob = new Date(val);

          // Check if date is valid
          if (isNaN(dob.getTime())) {
            toast.error("Invalid date format");
            formik.setFieldValue("dob", "");
            formik.setFieldTouched("dob", true);
            return;
          }

          const age =
            today.getFullYear() -
            dob.getFullYear() -
            (today < new Date(today.getFullYear(), dob.getMonth(), dob.getDate())
              ? 1
              : 0);

          if (age < 18) {
            toast.error(t("age"));
            formik.setFieldValue("dob", ""); // Clear DOB
            formik.setFieldTouched("dob", true);
            return; // stop
          }
        } catch (error) {
          toast.error("Invalid date format");
          return;
        }
      }

      formik.setFieldValue("dob", val);
      formik.setFieldTouched("dob", true);
    }}
    onBlur={formik.handleBlur}
    style={{ height: "40px", width: "100%", 
      border: formik.touched.dob && formik.errors.dob
        ? "2px solid #d32f2f"
        : "2px solid #091E4224"
    }}
  />
  {formik.touched.dob && formik.errors.dob && (
    <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
      {formik.errors.dob}
    </span>
  )}
</Box>


          </Box>


          <Box mb={2}>
            <label className="field_label">{t("profilePicture")}</label>

            <Box
              // onClick={!uploadedImage ? handleImagePick : undefined}
              onClick={(e) => {
if (uploadedImage) return;
e.stopPropagation();
setProfileMenuEl(e.currentTarget);
}}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                e.preventDefault();
                const file = e.dataTransfer.files?.[0];
                if (file) {
                  setUploadedImage(URL.createObjectURL(file));
                  setImageFile(file);
                  formik.setFieldValue("profile_image_file", file);
                }
              }}
              sx={{
                border: "2px dashed #091E4224",
                backgroundColor: "#F6F8FB",
                height: 130,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "6px",
                cursor: uploadedImage ? "default" : "pointer",
                position: "relative",
              }}
            >
              {uploadedImage ? (
                <>
                  {/* Check if it's a URL (edit mode) - make it clickable */}
                  {uploadedImage.startsWith("http://") || uploadedImage.startsWith("https://") ? (
                    <a
                    crossOrigin="anonymous"
                      href={uploadedImage}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        display: "block",
                        width: "100%",
                        height: "100%",
                        textDecoration: "none",
                      }}
                    >
                      <img
                      crossOrigin="anonymous"
                        src={uploadedImage}
                        alt="Profile Image"
                        style={{
                          maxHeight: "100%",
                          maxWidth: "100%",
                          objectFit: "contain",
                          borderRadius: "6px",
                          cursor: "pointer",
                        }}
                      />
                    </a>
                  ) : (
                    <img
                    crossOrigin="anonymous"
                      src={uploadedImage}
                      alt="Uploaded"
                      style={{
                        maxHeight: "100%",
                        maxWidth: "100%",
                        objectFit: "contain",
                        borderRadius: "6px",
                      }}
                    />
                  )}

                  {/* Cross icon */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 6,
                      right: 6,
                      backgroundColor: "rgba(0,0,0,0.6)",
                      borderRadius: "50%",
                      width: 24,
                      height: 24,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      zIndex: 2,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setUploadedImage(null);
                      setImageFile(null);
                      formik.setFieldValue("profile_image_file", null);
                      formik.setFieldValue("profile_image_url", "");
                    }}
                  >
                    <span
                      style={{
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "16px",
                        lineHeight: "16px",
                      }}
                    >
                      ×
                    </span>
                  </Box>
                </>
              ) : (
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <img src={drag} alt="drag" />
                  <span style={{ fontSize: "15px", fontWeight: 500 }}>
                    {t("addCompanyAdmin.dragFiles")}{" "}
                    <span style={{ color: "#0052CC" }}>{t("addCompanyAdmin.browse")}</span>
                  </span>
                </Box>
              )}

             
            </Box>
             <input
                type="file"
                ref={imageInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept="image/*"
              />
            <Menu
  anchorEl={profileMenuEl}
  open={Boolean(profileMenuEl)}
  onClose={() => setProfileMenuEl(null)}
>
  <MenuItem 
  // onClick={() => {
  //   setProfileMenuEl(null);
  //   openCamera("profile");
  // }}
    onClick={() => {
    setProfileMenuEl(null);
    setTimeout(() => {
      openCamera("profile");
    }, 0);
  }}
  sx={{fontSize:"13px",
          fontFamily: 'Poppins, sans-serif',
  }}
  >
  {t("takePhoto")}
  </MenuItem>

  <MenuItem 
  // onClick={() => {
  //   setProfileMenuEl(null);
  //   handleImagePick();
  // }}
  onClick={() => {
    setProfileMenuEl(null);   // close menu first
    setTriggerProfileFile(true); // trigger file input after close
  }}
  sx={{fontSize:"13px",
          fontFamily: 'Poppins, sans-serif',
  }}
  >
    {t("chooseFromGallery")}
  </MenuItem>
</Menu>
          </Box>


          {/* Employment Details */}
          <Box mt={2.5}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CustomText
                sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 600, color: "#000", textAlign: "left" }}
              >
                {t("addCompanyAdmin.employmentDetails")}
              </CustomText>
              {/* <img src={down} width={40} height={30} alt="down" /> */}
            </Box>

            <Box display="flex" gap={1.5} mb={2}>
              {/* Department (from API, sets department_id) */}
              <Box sx={{ flex: 1 }}
                >
                <label className="field_label">
                  {t("addCompanyAdmin.department")}  <span className="red_asterisk">*</span>
                </label>
                <div className="dropdown-wrapper">
                  <div
                    className={`dropdown-header ${departmentDropdownOpen ? "open" : ""}`}
                    onClick={() => setDepartmentDropdownOpen((s) => !s)}
                  >
                    {deptLoading
                      ? t("loading") || "Loading..."
                      : deptError
                        ? t("retry") || "Retry"
                        : departments.length
                          ? departments.find((d) => d.id === Number(formik.values.department_id))?.name ||
                          t("addCompanyAdmin.select")
                          : t("noData") || "No departments"}
                    <span
                      style={{
                        transform: departmentDropdownOpen ? "rotate(180deg)" : "rotate(0)",
                        transition: "0.3s",
                      }}
                    >
                      <img src={arrow} alt="arrow" />
                    </span>
                  </div>

                  {departmentDropdownOpen && (
                    <div className="dropdown-list" style={{ maxHeight: 240, overflowY: "auto" }}>
                      {/* Search Input */}
                      <div style={{ padding: "8px", borderBottom: "1px solid #e0e0e0" }}>
                        <input
                          type="text"
                          placeholder={t("search") || "Search departments..."}
                          value={deptSearchQuery}
                          onChange={(e) => setDeptSearchQuery(e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            width: "100%",
                            padding: "8px 12px",
                            fontSize: "14px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontFamily: "Poppins, sans-serif",
                            outline: "none",
                          }}
                        />
                      </div>

                      {deptLoading && (
                        <div className="dropdown-item" style={{ opacity: 0.7 }}>
                          {t("loading") || "Loading..."}
                        </div>
                      )}

                      {deptError && (
                        <div
                          className="dropdown-item"
                          style={{ color: "#c62828" }}
                          onClick={fetchDepartments}
                        >
                          {t("retry") || "Retry"}
                        </div>
                      )}

                      {!deptLoading && !deptError && filteredDepartments.length === 0 && (
                        <div className="dropdown-item" style={{ opacity: 0.7 }}>
                          {deptSearchQuery ? (t("noResults") || "No departments found") : (t("noData") || "No departments")}
                        </div>
                      )}

                      {!deptLoading &&
                        !deptError &&
                        filteredDepartments.map((dept) => (
                          <div
                            key={dept.id}
                            className={`dropdown-item ${Number(formik.values.department_id) === dept.id ? "selected" : ""
                              }`}
                            onClick={() => {
                              formik.setFieldValue("department_id", dept.id);
                              formik.setFieldTouched("department_id", true);
                              setDepartmentDropdownOpen(false);
                              setDeptSearchQuery("");
                              fetchDepartmentSchedule(dept.id);
                            }}
                          >
                            {dept.name}
                          </div>
                        ))}
                    </div>
                  )}
                </div>
                {/* hidden input to enable focus on validation */}
                <input 
                  type="hidden" 
                  name="department_id" 
                  value={formik.values.department_id}
                  onBlur={() => formik.setFieldTouched("department_id", true)}
                />
              </Box>

              {/* Position/Designation */}
              <Box sx={{ flex: 1 }}>
                <label className="field_label">
                  {t("addWorker.position")}
                </label>
                <input
                  className="project_input"
                  name="designation"
                  value={formik.values.designation}
                  onChange={formik.handleChange}
                  style={{ height: "40px", width: "100%" }}
                  placeholder={t("addWorker.enterPosition")}
                />
              </Box>
            </Box>


            <Box display="flex" gap={1.5} mb={2} >
              {/* Employee Type */}
              <Box sx={{ flex: 1 }}>
                <label className="field_label">
                  {t("addCompanyAdmin.employeeType")} 
                </label>
                <div
                  className="dropdown-wrapper"
                  style={formik.touched.employee_type && formik.errors.employee_type ? { border: "2px solid #d32f2f" } : {}}
                >
                  <div
                    className={`dropdown-header ${employeeTypeDropdownOpen ? "open" : ""}`}
                    onClick={() => setEmployeeTypeDropdownOpen((s) => !s)}
                  >
                    {employeeTypes.find(et => et.value === formik.values.employee_type)?.label || t("addCompanyAdmin.select")}
                    <span
                      style={{
                        transform: employeeTypeDropdownOpen ? "rotate(180deg)" : "rotate(0)",
                        transition: "0.3s",
                      }}
                    >
                      <img src={arrow} alt="arrow" />
                    </span>
                  </div>

                  {employeeTypeDropdownOpen && (
                    <div className="dropdown-list">
                      {employeeTypes.map((type) => (
                        <div
                          key={type.value}
                          className={`dropdown-item ${formik.values.employee_type === type.value ? "selected" : ""}`}
                          onClick={() => {
                            formik.setFieldValue("employee_type", type.value);
                            formik.setFieldTouched("employee_type", true);
                            setEmployeeTypeDropdownOpen(false);
                          }}
                        >
                          {type.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <input 
                  type="hidden" 
                  name="employee_type" 
                  value={formik.values.employee_type}
                  onBlur={() => formik.setFieldTouched("employee_type", true)}
                />
                {formik.touched.employee_type && formik.errors.employee_type && (
                  <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                    {formik.errors.employee_type}
                  </span>
                )}
              </Box>

              {/* Hire Date */}
              <Box sx={{ flex: 1 }}>
                <label className="field_label">
                  {t("addCompanyAdmin.hireDate")} 
                </label>
         
                <input
                   ref={hireRef}
                  type="date"
                  className="project_input"
                  name="hire_date"
                  value={formik.values.hire_date || ""}
                      onClick={() => hireRef.current?.showPicker()} 

                  onChange={(e) => {
                    let val = e.target.value;
                    // Extract parts safely
                    const parts = val.split("-");
                    const year = parts[0] || "";

                    // Enforce 4-digit year without breaking the date
                    if (year.length > 4) {
                      const fixedYear = year.slice(0, 4);
                      parts[0] = fixedYear;
                      val = parts.join("-");
                    }

                    // Validate format: yyyy-mm-dd or partial valid
                    const validFormat = /^\d{0,4}(-\d{0,2}){0,2}$/;
                    if (validFormat.test(val)) {
                      formik.setFieldValue("hire_date", val);
                      formik.setFieldTouched("hire_date", true);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  style={{ height: "40px", width: "100%", 
                    border: formik.touched.hire_date && formik.errors.hire_date
                      ? "2px solid #d32f2f"
                      : "2px solid #091E4224"
                  }}
                />
                {formik.touched.hire_date && formik.errors.hire_date && (
                  <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                    {formik.errors.hire_date}
                  </span>
                )}
              </Box>
            </Box>

          </Box>


   
          <Box mb={2}>
            <label className="field_label">
              {t("addCompanyAdmin.shiftSchedule")}
            </label>
            <div
              className="dropdown-wrapper"
              style={formik.touched.shift_schedule && formik.errors.shift_schedule ? { border: "2px solid #d32f2f" } : {}}
            >
              <div
                className={`dropdown-header ${shiftDropdownOpen ? "open" : ""}`}
                onClick={() => setShiftDropdownOpen((s) => !s)}
              >
                {shiftOptions.find(so => so.value === formik.values.shift_schedule)?.label || t("addCompanyAdmin.select")}
                <span
                  style={{
                    transform: shiftDropdownOpen ? "rotate(180deg)" : "rotate(0)",
                    transition: "0.3s",
                  }}
                >
                  <img src={arrow} alt="arrow" />
                </span>
              </div>

              {shiftDropdownOpen && (
                <div className="dropdown-list" style={{
                  zIndex: 9999,
                }}>
                  {shiftOptions.map((shift) => (
                    <div
                      key={shift.value}
                      className={`dropdown-item ${formik.values.shift_schedule === shift.value ? "selected" : ""
                        }`}
                      onClick={() => {
                        formik.setFieldValue("shift_schedule", shift.value);
                        formik.setFieldTouched("shift_schedule", true);
                        setShiftDropdownOpen(false);
                      }}
                    >
                      {shift.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <input 
              type="hidden" 
              name="shift_schedule" 
              value={formik.values.shift_schedule}
              onBlur={() => formik.setFieldTouched("shift_schedule", true)}
            />
            {formik.touched.shift_schedule && formik.errors.shift_schedule && (
              <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                {formik.errors.shift_schedule}
              </span>
            )}
          </Box>

          {/* Additional Fields: Salary, Work Hours, Document URL */}
          <Box display="flex" gap={1.5} mb={2}>
            <Box sx={{ flex: 1 }}>
              <label className="field_label">
                {t("salary") || "Salary"}
              </label>
              <input
                type="number"
                className="project_input"
                name="salary"
                // value={formik.values.salary}
                  value={formik.values.salary ?? ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                min="0"
                onKeyDown={(e) => {
                  if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                    e.preventDefault();
                  }
                }}
                style={{ height: "40px", width: "100%" }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <label className="field_label">
                {t("workHours") || "Work Hours"}
              </label>
              <input
                type="number"
                className="project_input"
                name="work_hours"
                value={formik.values.work_hours}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                min="0"
                onKeyDown={(e) => {
                  if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                    e.preventDefault();
                  }
                }}
                style={{ height: "40px", width: "100%" }}
              />
            </Box>
          </Box>




<Box mb={2}>
  <label className="field_label">
    {t("nationalId.label")}
  </label>

  <Box
onClick={(e) => {
if (documentFileName || uploadingDocument) return;
e.stopPropagation();
setDocMenuEl(e.currentTarget);
}}    onDragOver={(e) => e.preventDefault()}
    onDrop={(e) => {
      e.preventDefault();
      const file = e.dataTransfer.files?.[0];
      if (file) {
        const allowed = [
          "application/pdf",
          "image/png",
          "image/jpeg",
          "image/jpg",
        ];
        if (allowed.includes(file.type)) {
          handleDocumentChange({ target: { files: [file] } });
        } else {
          toast.error(t("fileValidation.label"));
        }
      }
    }}
    sx={{
      border: "2px dashed #091E4224",
      backgroundColor: "#F6F8FB",
      height: 130,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "6px",
      cursor: uploadingDocument ? "not-allowed" : "pointer",
      position: "relative",
    }}
  >
    {/* ❌ Remove button */}
    {(documentFileName || documentImageUrl) && !uploadingDocument && (
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          setDocumentFileName("");
          setDocumentImageUrl(null);
          formik.setFieldValue("document_url", "");
          if (documentInputRef.current) documentInputRef.current.value = "";
          toast(t("addWorker.documentRemoved"));
        }}
        sx={{
          position: "absolute",
          top: 4,
          right: 4,
          backgroundColor: "#fff",
          border: "1px solid #ccc",
          width: 24,
          height: 24,
          "&:hover": { backgroundColor: "#f2f2f2" },
        }}
      >
        ✕
      </IconButton>
    )}

    {/* UPLOADING */}
    {uploadingDocument ? (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
        <CircularProgress size={24} />
        <span style={{ fontSize: "14px", color: "#626F86" }}>{t("loading")}</span>
      </Box>
    ) : (documentFileName || documentImageUrl) ? (
      /* PREVIEW MODE (PDF or IMAGE) */
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>

        {/* Show icon based on type */}
        <img
          src={getDocumentIcon(documentFileName || documentImageUrl)}
          alt="file-icon"
          style={{ width: 40, height: 40 }}
        />

        {/* Name */}
        <span style={{ fontSize: "14px", color: "#172B4D", fontWeight: 500 }}>
          {documentFileName || "National ID Document"}
        </span>

        {/* View Document link */}
        {(documentImageUrl?.startsWith("http://") || documentImageUrl?.startsWith("https://")) && (
          <a
            href={documentImageUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{
              fontSize: "12px",
              color: "#0052CC",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {t("workerDetails.viewDocument")}
          </a>
        )}

        <span style={{ fontSize: "12px", color: "#626F86" }}>
          {t("addWorker.changeDocument")}
        </span>
      </Box>
    ) : (
      /* EMPTY STATE */
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
        <img src={drag} alt="drag" />
        <span style={{ fontSize: "15px", fontWeight: 500, color: "#626F86" }}>
          {t("addWorker.dragHere")}{" "}
          <span style={{ color: "#0052CC", textDecoration: "underline" }}>
            {t("addWorker.clickBrowse")}
          </span>
        </span>
      </Box>
    )}
  </Box>
  <Menu
  anchorEl={docMenuEl}
  open={Boolean(docMenuEl)}
  onClose={() => setDocMenuEl(null)}
>
  <MenuItem 
  // onClick={() => {
  //   setDocMenuEl(null);
  //   openCamera("nationalId");
  // }}
    onClick={() => {
    setDocMenuEl(null);
    setTimeout(() => {
      openCamera("nationalId");
    }, 0);
  }}
  sx={{fontSize:"13px",
          fontFamily: 'Poppins, sans-serif',
  }}
  >
   {t("takePhoto")}
  </MenuItem>

  <MenuItem 
  // onClick={() => {
  //   setDocMenuEl(null);
  //   handleDocumentPick();
  // }}
    onClick={() => {
    setDocMenuEl(null);
    setTimeout(() => {
      handleDocumentPick();
    }, 0);
  }}
   sx={{fontSize:"13px",
          fontFamily: 'Poppins, sans-serif',
  }}
  >
   {t("chooseFromGallery")}
  </MenuItem>
</Menu>

  <span style={{ fontSize: "12px", color: "#626F86" }}>
    {t("fileTypeRestriction")}
  </span>

  <input
    type="file"
    ref={documentInputRef}
    style={{ display: "none" }}
    onChange={handleDocumentChange}
    accept="image/*,.pdf"
  />
</Box>



          {/* Work Configuration */}
          <Box mt={2.5}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CustomText
                sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 600, color: "#000", textAlign: "left" }}
              >
                {t("addCompanyAdmin.workConfiguration")}
              </CustomText>
            </Box>



      <Box sx={{ display: "flex", alignItems: "center",gap:1, mb: 1, mt: 2, }}>
              <input
                type="checkbox"
                id="manualAddress"
                checked={showManualAddress}
                onChange={(e) => handleManualAddressToggle(e.target.checked)}
                style={{ marginRight: 8 }}
              />
              <label htmlFor="manualAddress" style={{ fontSize: 16, fontWeight: 500, color: "#2C384C", cursor: "pointer" }}>
                {t("addWorker.manualAddress")}
              </label>
            </Box>

            {/* Show Location component only when manual address is not checked */}
            {!showManualAddress && (
              <Location
                onPermission={(allowed) => {
                  setLocationAllowed(allowed);
                  if (allowed) {
                    // Permission granted (e.g. re-enabled in the browser) - close the modal
                    setShowPermissionModal(false);
                  } else {
                    // 🚨 Open modal here instead of default center
                    setShowPermissionModal(true);
                  }
                }}
                externalCenter={externalCenter}
                initialAddress={initialAddress}
                hideAddressOnEdit={!!workerToEdit}
                onChange={(loc) => {
                  // Update formik values from reverse geocoded address
                  // Only update if the field is empty or if we're in edit mode and want to supplement
                  const currentValues = formik.values;
                  
                  // Always update lat/long
                  formik.setFieldValue("latitude", loc.latitude);
                  formik.setFieldValue("longitude", loc.longitude);
                  
                  // Update address fields - use reverse geocoded values to fill empty fields
                  if (loc.country && (!currentValues.country || workerToEdit)) {
                    formik.setFieldValue("country", loc.country);
                    setSelectedCountry(loc.country);
                  }
                  if (loc.city && (!currentValues.city || workerToEdit)) {
                    formik.setFieldValue("city", loc.city);
                    setSelectedCity(loc.city);
                  }
                  if (loc.province && (!currentValues.province || workerToEdit)) {
                    formik.setFieldValue("province", loc.province);
                    setSelectedProvince(loc.province);
                  }
                  if (loc.community && (!currentValues.community || workerToEdit)) {
                    formik.setFieldValue("community", loc.community);
                  }
                  if (loc.postalCode && (!currentValues.postal_code || workerToEdit)) {
                    formik.setFieldValue("postal_code", loc.postalCode);
                  }
                  if (loc.streetAddress && (!currentValues.street_address || workerToEdit)) {
                    formik.setFieldValue("street_address", loc.streetAddress);
                  }
                  if (loc.region) {
                    formik.setFieldValue("assign_region", [loc.region]);
                  }
                }}
              />
            )}

      
          </Box>

          {/* Manual Address Section - Below Map */}
          <Box mt={2.5}>




            {showManualAddress && (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 2 }}>
    {/* Country Dropdown */}
    <Box>
      <label className="field_label">{t("addWorker.country")}</label> <span className="red_asterisk">*</span>
      <div className="dropdown-wrapper">
        <div
          className="dropdown-header"
          onClick={() => {
            if (!loadingCountries) {
              setCountryDropdownOpen(!countryDropdownOpen);
            }
          }}
        >
          {loadingCountries ? "Loading..." : selectedCountry || t("addWorker.selectCountry")}
          <span
            style={{
              transform: countryDropdownOpen ? "rotate(180deg)" : "rotate(0)",
              transition: "0.3s",
            }}
          >
            <img src={arrow} alt="arrow" />
          </span>
        </div>

        {countryDropdownOpen && (
          <div className="dropdown-list" style={{ maxHeight: "200px", overflowY: "auto" }}>
            {/* Search Input for Country */}
            <InputBase
              placeholder={t("searchPlaceholder")}
              value={searchCountry}
              onChange={(e) => setSearchCountry(e.target.value)}
              sx={{
                width: "100%",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "6px",
                px: 1,
                py: 0.7,
                fontSize: "14px",
                fontFamily: "Poppins, sans-serif",
                marginBottom: "8px",
                "&:focus": {
                  borderColor: "#1976d2",
                  boxShadow: "0 0 0 2px rgba(25,118,210,0.2)",
                },
              }}
            />

            {countriesData
              .filter((c) => c.name.toLowerCase().includes(searchCountry.toLowerCase()))
              .map((c) => (
                <div
                  key={c.isoCode}
                  className="dropdown-item"
                  // onClick={() => {
                  //   handleCountryChange(c.name);
                  //   setCountryDropdownOpen(false);
                  // }}
                  onClick={() => {
  handleCountryChange(c); // pass full object
  setCountryDropdownOpen(false);
}}
                >
                  {c.name}
                </div>
              ))}
          </div>
        )}
      </div>
    </Box>
{formik.touched.country && formik.errors.country && (
  <span style={{ color: "#d32f2f", fontSize: "12px" }}>
    {formik.errors.country}
  </span>
)}
    {/* Province/State Dropdown */}
    {selectedCountry && (
      <Box>
        <label className="field_label">{t("addWorker.province")}</label> <span className="red_asterisk">*</span>
        <div className="dropdown-wrapper">
          <div
            className="dropdown-header"
            onClick={() => !loadingProvinces && setProvinceDropdownOpen(!provinceDropdownOpen)}
          >
            {/* {loadingProvinces ? "Loading..." : selectedProvince || t("addWorker.selectProvince")} */}
          {loadingProvinces ? "Loading..." : formik.values.province || t("addWorker.selectProvince")}

          
            <span
              style={{
                transform: provinceDropdownOpen ? "rotate(180deg)" : "rotate(0)",
                transition: "0.3s",
              }}
            >
              <img src={arrow} alt="arrow" />
            </span>
          </div>

          {provinceDropdownOpen && (
            <div className="dropdown-list" style={{ maxHeight: "200px", overflowY: "auto" }}>
              {/* Search Input for Province */}
              <InputBase
                placeholder={t("searchPlaceholder")}
                value={searchProvince}
                onChange={(e) => setSearchProvince(e.target.value)}
                sx={{
                  width: "100%",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  px: 1,
                  py: 0.7,
                  fontSize: "14px",
                  fontFamily: "Poppins, sans-serif",
                  marginBottom: "8px",
                  "&:focus": {
                    borderColor: "#1976d2",
                    boxShadow: "0 0 0 2px rgba(25,118,210,0.2)",
                  },
                }}
              />

              {statesList
                .filter((s) => s.name.toLowerCase().includes(searchProvince.toLowerCase()))
                .map((s) => (
                  <div
                    key={s.isoCode}
                    className="dropdown-item"
                    onClick={() => {
                      handleStateChange(s.name);
                      setProvinceDropdownOpen(false);
                    }}
                  >
                    {s.name}
                  </div>
                ))}
            </div>
          )}
        </div>
      </Box>
    )}
    {formik.touched.province && formik.errors.province && (
  <span style={{ color: "#d32f2f", fontSize: "12px" }}>
    {formik.errors.province}
  </span>
)}

    {/* City Dropdown */}
    {selectedProvince && (
      <Box>
        <label className="field_label">{t("addWorker.city")}</label> <span className="red_asterisk">*</span>
        <div className="dropdown-wrapper">
          <div
            className="dropdown-header"
            onClick={() => !loadingCities && setCityDropdownOpen(!cityDropdownOpen)}
          >
            {loadingCities ? "Loading..." : selectedCity || t("addWorker.selectCity")}
            <span
              style={{
                transform: cityDropdownOpen ? "rotate(180deg)" : "rotate(0)",
                transition: "0.3s",
              }}
            >
              <img src={arrow} alt="arrow" />
            </span>
          </div>

          {cityDropdownOpen && (
            <div className="dropdown-list" style={{ maxHeight: "200px", overflowY: "auto" }}>
              {/* Search Input for City */}
              <InputBase
                placeholder={t("searchPlaceholder")}
                value={searchCity}
                onChange={(e) => setSearchCity(e.target.value)}
                sx={{
                  width: "100%",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  px: 1,
                  py: 0.7,
                  fontSize: "14px",
                  fontFamily: "Poppins, sans-serif",
                  marginBottom: "8px",
                  "&:focus": {
                    borderColor: "#1976d2",
                    boxShadow: "0 0 0 2px rgba(25,118,210,0.2)",
                  },
                }}
              />

              {citiesList
                .filter((city) => city.toLowerCase().includes(searchCity.toLowerCase()))
                .map((city) => (
                  <div
                    key={city}
                    className="dropdown-item"
                    onClick={() => {
                      handleCityChange(city);
                      setCityDropdownOpen(false);
                    }}
                  >
                    {city}
                  </div>
                ))}
            </div>
          )}
        </div>
      </Box>
    )}
{formik.touched.city && formik.errors.city && (
  <span style={{ color: "#d32f2f", fontSize: "12px" }}>
    {formik.errors.city}
  </span>
)}
    {/* Work Address Field */}
    <Box>
      <label className="field_label">{t("addWorker.workAddress")}</label>
      <input
        className="project_input"
        name="work_address"
        value={formik.values.work_address}
        onChange={formik.handleChange}
        style={{ height: "40px", width: "100%" }}
        placeholder={t("enterWorkAddress")}
      />
    </Box>
  </Box>
)}


          </Box>


          {/* Footer - Save */}
          <Box sx={{ mt: 3 }}>
            {/* <CustomButton
              // onClick={formik.handleSubmit}
              onClick={() => {
                if (locationAllowed === false) {
                  // 🚨 show modal instead of submitting
                  setShowPermissionModal(true);
                  return;
                }
                formik.handleSubmit();
              }}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#ffffff" }}>
                  {loading && <CircularProgress size={18} thickness={4} sx={{ color: "#ffffff" }} />}
                  <img src={save} alt="save" style={{ width: 16, height: 16 }} />
                  <span style={{ color: "#ffffff" }}>          {workerToEdit? t("save") : t("addCompanyAdmin.saveInvite")}
</span>
                </Box>
              }
              size="medium"
            /> */}


            <CustomButton
  onClick={() => {
    console.log("==================================");
    console.log("🖱️ SAVE BUTTON CLICKED");
    console.log("==================================");
    console.log("📍 Location Allowed:", locationAllowed);
    console.log("📍 Show Manual Address:", showManualAddress);
    console.log("📋 Current Form Values:", formik.values);
    console.log("❌ Current Form Errors:", formik.errors);
    console.log("👆 Touched Fields:", formik.touched);
    console.log("✅ Form Valid:", formik.isValid);
    console.log("🔄 Form Submitting:", formik.isSubmitting);
    
    if (locationAllowed === false) {
      console.log("⚠️ Location permission denied - showing modal");
      setShowPermissionModal(true);
      return;
    }
    
    console.log("✅ Proceeding to form submission...");
    formik.handleSubmit();
  }}
  label={
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#ffffff" }}>
      {loading && <CircularProgress size={18} thickness={4} sx={{ color: "#ffffff" }} />}
      <img src={save} alt="save" style={{ width: 16, height: 16 }} />
      <span style={{ color: "#ffffff" }}>
        {workerToEdit ? t("save") : t("addCompanyAdmin.saveInvite")}
      </span>
    </Box>
  }
  size="medium"
/>

          </Box>
        </Box>
        <LocationPermissionModal
          open={showPermissionModal}
          onAllow={() => {
            setShowPermissionModal(false);
            setLocationAllowed(true);
          }}
          onCancel={() => setShowPermissionModal(false)}
        />

      </Drawer>

      <UpgradePromptModal
        open={showUpgradeModal}
        message={upgradeMessage}
        onClose={() => setShowUpgradeModal(false)}
        onConfirm={() => {
          setShowUpgradeModal(false);
          navigate("/subscription-plans");
        }}
      />
{showCamera && (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1300,
      p: 2,
    }}
  >
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: 600,
      }}
    >
      <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        {!capturedImage ? (
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={{ facingMode: "user", width: 600, height: 450 }}
            style={{
              borderRadius: "12px",
              width: "100%",
              maxWidth: "600px",
              objectFit: "cover",
              border: "2px solid #E0E0E0",
            }}
          />
        ) : (
          <img
            src={capturedImage}
            alt="Captured"
            style={{
              borderRadius: "12px",
              width: "100%",
              maxWidth: "600px",
              border: "2px solid #E0E0E0",
            }}
          />
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          mt: 3,
          width: "100%",
        }}
      >
        {!capturedImage ? (
          <CustomButton
           label={ t("capture")}
            onClick={capturePhoto}
            sx={{
              flex: 1,
              py: 1.2,
              borderRadius: "8px",
            }}
          />
        ) : (
          <CustomButton
            label={t("retake")}
            onClick={() => setCapturedImage(null)}
            sx={{
              flex: 1,
              py: 1.2,
              borderRadius: "8px",
            }}
          />
        )}
        <CustomButton
        label={t("close")}

          onClick={() => setShowCamera(false)}
          sx={{
            flex: 1,
            py: 1.2,
            borderRadius: "8px",
            backgroundColor: "#E0E0E0",
            color: "#333",
            "&:hover": { backgroundColor: "#D5D5D5" },
          }}
        />
      </Box>
    </Box>
  </Box>
)}
    </>

  );
};
export default AddWorkers;










